<template>
  <main class="login-template"><slot></slot></main>
</template>

<script>
export default { name: "PlantillaLogin" };
</script>

<style scoped>
.login-template { min-height: 100vh; }
</style>

<style lang="scss">
  @import "~bulma/sass/utilities/_all";
  $my-primary: #99cca9;
  $link: #99cca9;
  $primary-invert: white;
  $colors: (
    "primary": ($my-primary, $primary-invert),
    "pagination-focus-border-color": (#99cca9, black),
  );
  @import "~bulma";
  @import "~buefy/src/scss/buefy";
</style>
